import React from 'react';
import { useLocation, useNavigate } from 'react-router';
import { FormattedMessage } from 'react-intl';

import { Help, Icon, LanguageSelect, Spinner } from 'components/ui';

import useUsedSlots from './useUsedSlots';
import StandardDateTime from 'components/ui/Dates/StandardDateTime';

interface HeaderProps {
  disableNavigation?: boolean;
}

const Header: React.FC<HeaderProps> = ({ disableNavigation }) => {
  const navigate = useNavigate();
  const { search, pathname } = useLocation();

  const [date, setDate] = React.useState(new Date());

  const {
    slots, usedSlots, isFetching, isSuccess,
  } = useUsedSlots({ refetch: true });

  React.useLayoutEffect(() => {
    const timeoutId = setTimeout(() => setDate(new Date()), 60000);
    return () => {
      if (timeoutId) {
        clearTimeout(timeoutId);
      }
    };
  }, [date]);

  const handleClickSlots = React.useCallback(() => {
    if (!disableNavigation) {
      navigate(`/admin/slots${search}`, { replace: pathname === '/admin/slots' });
    }
  }, [disableNavigation, navigate, pathname, search]);

  return (
    <div className="flex w-full justify-between items-center z-20 px-12 fixed bg-white/90 backdrop-blur-xs">
      <div className="flex flex-1 items-center gap-4">
        <Help />
        <p className="text-xl! font-bold text-default whitespace-nowrap" data-testid="admin-date">
          <StandardDateTime value={date} />
        </p>
      </div>
      <div
        className="flex items-center justify-center px-6 py-4 rounded-admin-card bg-card-bg gap-5 cursor-pointer"
        onClick={handleClickSlots}
        data-testid="header-slots"
      >
        {isFetching && <Spinner />}
        {isSuccess && (
          <>
            <p className="text-xl! font-bold text-default" data-testid="usedSlots">
              <FormattedMessage
                id="admin.slotsSummary"
                defaultMessage="{used} of {max} slots used"
                values={{ used: usedSlots, max: slots }}
              />
            </p>
            <Icon className="fb-icon--slot text-5xl text-default" />
          </>
        )}
      </div>
      <div className="flex flex-1 justify-end">
        <LanguageSelect />
      </div>
    </div>
  );
};

export default Header;
